import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { BEACH_GALLERY } from "@/data/siteData";

export default function BeachGallery() {
  const row = [...BEACH_GALLERY, ...BEACH_GALLERY];
  return (
    <section data-testid="beach-gallery-section" className="pb-20 sm:pb-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="max-w-7xl mx-auto px-5 sm:px-8 mb-10"
      >
        <p className="text-[11px] sm:text-xs uppercase tracking-[0.32em] text-gold font-semibold mb-4">Beach Gallery</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
          Goa&apos;s Finest <span className="gold-text italic">Shores</span>
        </h2>
      </motion.div>

      <div className="relative overflow-hidden" data-testid="beach-gallery-strip">
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-navy-abyss to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-navy-abyss to-transparent z-10 pointer-events-none" />
        <div
          className="gallery-track flex w-max gap-4 sm:gap-6 animate-marquee"
          style={{ animationDuration: "70s" }}
        >
          {row.map((b, i) => (
            <figure
              key={`${b.id}-${i}`}
              data-testid={i < BEACH_GALLERY.length ? `beach-gallery-item-${b.id}` : undefined}
              className="group relative w-64 sm:w-80 h-44 sm:h-56 rounded-2xl overflow-hidden border border-[#DC2626]/20 hover:border-gold/60 shadow-sm transition-[border-color] duration-500 shrink-0"
            >
              <img
                src={b.url}
                alt={b.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-abyss/85 via-transparent to-transparent" />
              <figcaption className="absolute bottom-3.5 left-4 flex items-center gap-1.5">
                <MapPin className="w-3.5 h-3.5 text-gold" />
                <span className="font-cinzel text-xs sm:text-sm tracking-[0.18em] uppercase text-ivory">{b.name}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
